import { render } from "./SocialMedia.vue?vue&type=template&id=377cae04&ts=true"
import script from "./SocialMedia.vue?vue&type=script&lang=ts"
export * from "./SocialMedia.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=377cae04&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__